import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=80671d4a&scoped=true&"
var script = {}
import style0 from "./Contacts.vue?vue&type=style&index=0&id=80671d4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80671d4a",
  null
  
)

export default component.exports